// extracted by mini-css-extract-plugin
export default {"noteTitle":"EditAssignmentNote-module__noteTitle___C62_g"};